import { callFunction } from './functionsClient';
import type { TokenPackage } from '../types';

export const paymentsApi = {
  listPackages: () =>
    callFunction<{ packages: TokenPackage[] }>('list-packages'),
  submitProof: (packageId: string, proofUrl: string) =>
    callFunction<{ requestId: string; status: string }>('submit-proof', {
      method: 'POST',
      body: { packageId, proofUrl },
    }),
};
